import {
    Button,
    Typography,
    Alert,
    Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom'
import ClickEmoji from '../../../shared-components/emojis/ClickEmoji';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserCompanyData } from '../../../../actions/carbonfootprint-rework/00-base/00-base-actions';

const headerButtons = [
    {
        text: 'Data Capturing',
        url: '/data-capturing'
    },
    {
        text: 'Conversion Factors',
        url: '/conversion-factors'
    },
    {
        text: 'General Information',
        url: '/general-information'
    },
]

const DashboardIntro = ({ isOpen }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const deepBlue = '#212746'
    const { companyId, groupId } = useSelector(state => state.auth.userData.carbonFootprintUser)
    // const groups = useSelector((state) => (state.carbonFootprintBase.userCompanyData?.data?.groups))

    useEffect(() => {
        if (companyId) {
            dispatch(getUserCompanyData(companyId, groupId))
        }
    }, [companyId])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <CFHeaderBanner page={'Home'}>
                Carbon Footprinting
            </CFHeaderBanner>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box>
                        <Typography variant='h6'>
                            Welcome to the Carbon Footprinting Web App!
                        </Typography>
                    </Box>
                    <Box>
                        <Typography sx={{ color: deepBlue }}>
                            Click the {isOpen
                                ? <ChevronLeftIcon sx={{ verticalAlign: 'bottom' }} />
                                : <MenuIcon sx={{ verticalAlign: 'bottom' }} />} button at the top left to
                            {isOpen
                                ? ' collapse'
                                : ' expand'} the sidebar.
                        </Typography>
                        <Typography sx={{ color: deepBlue }}>
                            Click <ClickEmoji /> on the buttons below for a shortcut to the relevant section.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 3 }}>
                    {headerButtons.map((button, index) => (
                        <Button
                            key={index}
                            variant="outlined"
                            onClick={() => navigate(button.url)}>
                            {button.text}
                        </Button>
                    ))}
                </Box>
                <Alert sx={{ width: 'fit-content' }} severity='info'>
                    Please e-mail <strong>lucy@mycharr.app</strong> should you have any questions or need assistance.
                </Alert>
            </Box>
        </Box>
    )
}

function CFHeaderBanner({ children, page }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', background: '#535988', borderRadius: 2, p: 2 }}>
            <Typography variant='h5' sx={{ fontWeight: 'bold', color: 'whitesmoke' }}>
                {children}
            </Typography>
            <Typography variant='h7' sx={{ fontWeight: 'bold', color: 'whitesmoke' }}>
                {page}
            </Typography>
        </Box>
    )
}

export default DashboardIntro